import { Analytics } from '@/behaviour/analytics/index'
import { $ } from '@/libs/jquery/index'

export class UsersSessionsNewPage {
  public readonly selectors: ISelectors = {
    base: '.sessions.new',
  }
  private base: JQuery | null = null

  constructor() {
    this.base = $(this.selectors.base)
    if (this.base.length) {
      this.init()
    }
  }

  public init(): void {
    this.notifyAnalytics()
  }

  private notifyAnalytics(): void {
    if ($('.toast:contains(Ваша учётная запись успешно подтверждена.)').length) {
      Analytics.sendGoalManually('registration_succeed', 'send', 'registrate')
    }
  }
}
